/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Social_Science17Inputs */

const en__field_enum_tuda_social_science17 = /** @type {(inputs: _Field_Enum_Tuda_Social_Science17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Sciences`)
};

const de__field_enum_tuda_social_science17 = /** @type {(inputs: _Field_Enum_Tuda_Social_Science17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialwissenschaften`)
};

/**
* | output |
* | --- |
* | "Social Sciences" |
*
* @param {_Field_Enum_Tuda_Social_Science17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_social_science17 = /** @type {((inputs?: _Field_Enum_Tuda_Social_Science17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Social_Science17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_social_science17(inputs)
	return de__field_enum_tuda_social_science17(inputs)
});
export { _field_enum_tuda_social_science17 as "_field_enum_TUDA_SOCIAL_SCIENCE" }